import axiosApi from "../axiosInstance";

const getSubCategoryList = async () => {
    try {
        const response = await axiosApi.get(`/SubCategory/GetAllSubCategory`);
        return response?.data;

        
    } catch (error) {
        console.log("Error getLocationList===>:", error);
         return error?.response?.data;
    }
};

const addSubCategory = async (body) => {
    try {
        const response = await axiosApi.post(`SubCategory/CreateSubCategory`, body);
        return response?.data;
     } catch (error) {
        console.log("Error getLocationList===>:", error);
         return error?.response?.data;
    }
};
// NEW: deleteSubCategory
const deleteSubCategory = async (id) => {
  try {
    const response = await axiosApi.delete(`/SubCategory/deleteSubCategory/${id}`);
    return response?.data;
  } catch (error) {
    console.log("Error deleteSubCategory===>:", error);
    return error?.response?.data;
  }
};

export const subCategoryService = {
  getSubCategoryList,
  addSubCategory,
  deleteSubCategory,
};